import { useGetPortfolioViewQuery } from "../../../services/valuations";

const usePortfolio = (masterAccountId) => {
    const { data, error, isError, isLoading, isFetching, isUninitialized, refetch } = useGetPortfolioViewQuery({ masterAccountId }/*, { refetchOnMountOrArgChange: true }*/);

    return {
        data,
        isLoading,
        isFetching,
        isError,
        error,
        reload : refetch
    };

};

export default usePortfolio;